import { FormattedDate, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import { SrAlert, Typography } from "components/common";
import { ImgWithFallback } from "../../../ImgWithFallback";

const Card = ({ status, cardNumber, activationDate, cancelStatus }) => {
  const intl = useIntl();

  // * status 0 for canceled, 1 for pending, 2 for active
  const getStatusText = [
    intl.formatMessage({ id: "common.canceled" }),
    intl.formatMessage({ id: "common.pending" }),
    intl.formatMessage({ id: "common.active" }),
  ];

  return (
    <Box display="flex" flexDirection="column" alignItems="center" paddingY={5}>
      <ImgWithFallback
        height={296}
        src="/cards/tarjeta-sr-my-ecommerce@2x.webp"
        fallback="/cards/tarjeta-sr-my-ecommerce@2x.png"
        alt="srpago"
      />

      {cancelStatus ? (
        <Box marginTop={4}>
          <SrAlert severity="warning">
            {intl.formatMessage({ id: "srPagoCard.card.cancelledCard" })}
          </SrAlert>
        </Box>
      ) : (
        <Box
          marginTop={4}
          display="grid"
          gridTemplateColumns="auto auto"
          gridColumnGap="20px"
          gridRowGap="10px"
        >
          <Typography variant="body1PrimaryColor">
            {intl.formatMessage({ id: "srPagoCard.cardNumber" })}:
          </Typography>
          <Typography>•••• {cardNumber}</Typography>
          <Typography variant="body1PrimaryColor">
            {intl.formatMessage({ id: "srPagoCard.activationDate" })}:
          </Typography>
          <Typography>
            <FormattedDate
              month="2-digit"
              year="2-digit"
              value={activationDate}
            />
          </Typography>
          <Typography variant="body1PrimaryColor">
            {intl.formatMessage({ id: "srPagoCard.status" })}:
          </Typography>
          <Typography>{getStatusText?.[status]}</Typography>
        </Box>
      )}
    </Box>
  );
};

Card.propTypes = {
  status: PropTypes.oneOf([0, 1, 2]).isRequired,
  cardNumber: PropTypes.string.isRequired,
  activationDate: PropTypes.string.isRequired,
  cancelStatus: PropTypes.number,
};

Card.defaultProps = {
  cancelStatus: undefined,
};

export default Card;
